// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2Ue3f","error":"Textarea_error__3L9G5","readonly":"Textarea_readonly__1dhhC","disabled":"Textarea_disabled__1lM8q"};